import { FC } from 'react';
import { Input } from 'antd';
import { useThemeContext, themeConfig } from '@/shared/theme';
import { Col } from '@/shared/ui';

type Props = {
  label?: string;
  placeholder?: string;
  maxLength?: number;
};

const { TextArea } = Input;

export const TextAreaEdit: FC<Props> = ({ label, placeholder, maxLength }) => {
  const { theme } = useThemeContext();
  return (
    <Col dataTestId="text-area-component" alignItems="flex-start">
      {Boolean(label) && (
        <label
          data-testid="text-area-label"
          style={{ color: themeConfig[theme].colors.text }}
        >
          {label}
        </label>
      )}
      <TextArea
        data-testid="text-area-input"
        placeholder={placeholder}
        showCount
        disabled
        maxLength={maxLength}
        rows={3}
        style={{
          marginTop: 8,
          color: themeConfig[theme].colors.text,
          width: '100%',
        }}
      />
    </Col>
  );
};
